import { FC, useCallback, useState } from 'react';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import DataUploadNavBar from './DataUploadNavBar';
import * as Styles from './DataUploadPageTemplate.styles';
import DataUploadTemplatesDialog from './DataUploadTemplatesDialog';

interface DataUploadTemplateParams {
  children: React.ReactNode;
  isLoading?: boolean;
}

const DataUploadPageTemplate: FC<DataUploadTemplateParams> = ({ children, isLoading }) => {
  const [isTemplatesDialogOpen, setIsTemplatesDialogOpen] = useState(false);

  const handleOpenTemplatesDialog = useCallback(() => {
    setIsTemplatesDialogOpen(true);
  }, []);

  const handleCloseTemplatesDialog = useCallback(() => {
    setIsTemplatesDialogOpen(false);
  }, []);

  return (
    <Styles.DataUpload>
      {isLoading ? (
        <PageSpinner />
      ) : (
        <>
          <Styles.Container>
            <DataUploadNavBar handleOpenTemplatesDialog={handleOpenTemplatesDialog} />
            <Styles.ContentContainer>{children}</Styles.ContentContainer>
          </Styles.Container>
          <DataUploadTemplatesDialog open={isTemplatesDialogOpen} onClose={handleCloseTemplatesDialog} />
        </>
      )}
    </Styles.DataUpload>
  );
};

export default DataUploadPageTemplate;
